<template>
	<div class="parts-locations-scanner-card">
		<ul>
			<li>Barcode Scanner</li>
			<li>What is updated using the selected scanner?</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'PartsLocationsScannerCard'
};
</script>

<style lang="scss" scoped>
.parts-locations-scanner-card {
	&__item {
		display: block;
	}
}
</style>
